import BigNumber from 'bignumber.js';

const API_URL = 'https://bff.staking.ankr.com/coingecko/matchain-usd';

interface ICoinGeckoResult {
  data: number;
}

export async function getMainTokenUSDRatio(): Promise<BigNumber> {
  const response = await fetch(API_URL);

  const result: ICoinGeckoResult = await response.json();
  if (!result.data) {
    throw new Error('Failed to fetch Matchain USD price');
  }

  return new BigNumber(result.data);
}
